import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {URLS} from '../../../environments/environment';
import {OrdersService} from '../../dashboard/orders/orders.service';
import {saveAs} from 'file-saver';
@Component({
  selector: 'app-share-order',
  templateUrl: './share-order.component.html',
  styleUrls: ['./share-order.component.scss']
})
export class ShareOrderComponent implements OnInit {
  @Input() order: any;
  shareUrl = URLS.API;
  @Output() saveOrderEvent = new EventEmitter<string>();

  constructor(private ordersService: OrdersService) {
  }

  ngOnInit(): void {
  }

  onShareClick(platform: string): void {
    if (!this.order.slug) {
      debugger;
      this.saveOrderEvent.emit(platform);
    } else {
      this.share(platform);
    }
  }

  onOrderSaved(success: boolean, platform: string): void {
    if (success) {
      this.share(platform);
    } else {
      // Handle error case
    }
  }

  share(platform: string) {
    switch (platform) {
      case 'print':
        window.open(this.shareUrl + 'pdf/' + this.order.slug.slug + '?print=true');
        break;
      case 'whatsapp':
        window.open(`https://wa.me?text=${encodeURIComponent(`מצורף תחשיב משוער ליבוא (${this.order.title || 'הזמנה מספר ' + this.order.id})`)} \n` + this.shareUrl + 'pdf/' + this.order.slug.slug);
        break;
      case 'savePdf':
        this.ordersService.exportOrderToPdf(this.order).subscribe(res => {
          let blob = new Blob([res], {type: 'application/pdf'});
          saveAs(blob, `order-${this.order.id}.pdf`);
        });
        break;
      case 'email':
        window.open(`mailto:?subject=מצורף תחשיב משוער ליבוא (${this.order.title || 'הזמנה מספר ' + this.order.id})&body=${encodeURI(this.shareUrl + 'pdf/' + this.order.slug.slug)}`);
        break;
    }
  }
}
